"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const IContainerInjection_1 = require("auto-widget-framework/src/Container/IContainerInjection");
const Mixin_1 = require("auto-widget-framework/src/Util/Mixin");
const configs_1 = require("../configs/configs");
class BaseFormValidationRenderer {
    constructor(formElement, validationConfig, validationCriteria, validator) {
        this.formElement = formElement;
        this.validationConfig = validationConfig;
        this.validationCriteria = validationCriteria;
        this.validator = validator;
    }
    static create(formElement, validationConfig, container) {
        return new this(formElement, validationConfig, container.get("validation_criteria"), container.get("validator"));
    }
    /**
     * @inheritDoc
     */
    removeForAll() {
        return Promise.resolve().then(() => {
            const promises = [];
            for (let i = 0, element; element = this.formElement.elements[i++];) {
                if (element.name) {
                    promises.push(this.removeForField(element.name));
                }
            }
            return Promise.all(promises);
        });
    }
    /**
     * @inheritDoc
     */
    removeForField(inputName) {
        return Promise.resolve().then(() => {
            const container = this.formElement.querySelector(`[${configs_1.configs.dataAttribute.validationMessageContainer}="${inputName}"]`);
            const input = this.formElement.querySelector(`[name="${inputName}"]`);
            input.classList.remove(configs_1.configs.utilityCSSClasses.isValid);
            input.classList.remove(configs_1.configs.utilityCSSClasses.isInvalid);
            if (container) {
                const messages = container.querySelectorAll(`.${configs_1.configs.utilityCSSClasses.isVisible}`);
                for (let i = 0, message; message = messages[i++];) {
                    message.classList.remove(configs_1.configs.utilityCSSClasses.isVisible);
                }
            }
        });
    }
    /**
     * @inheritDoc
     */
    display(errors) {
        return Promise.resolve().then(() => {
            // @TODO: This should not revalidate.
            this.validator.validateInputs(this.validationConfig, true, this.formElement);
        });
    }
    /**
     * @inheritDoc
     */
    displayForField(inputName, error) {
        return Promise.resolve().then(() => {
            // @TODO: This should not revalidate.
            const element = this.formElement.querySelector(`[name="${inputName}"]`);
            this.validationConfig.filter((rule) => {
                const input = this.formElement.querySelector(rule.inputId);
                return input && input.name === element.name;
            }).forEach((rule) => this.validator.validateInput(rule, this.formElement));
        });
    }
}
exports.default = BaseFormValidationRenderer;
Mixin_1.default(BaseFormValidationRenderer, IContainerInjection_1.default);
